import { render } from "./FilterLabel.vue?vue&type=template&id=09b8e32a&scoped=true"
import script from "./FilterLabel.vue?vue&type=script&lang=js"
export * from "./FilterLabel.vue?vue&type=script&lang=js"

import "./FilterLabel.vue?vue&type=style&index=0&id=09b8e32a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09b8e32a"]])

export default __exports__